/* eslint-disable react/jsx-filename-extension */
import React, { useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import Button from 'src/components/Button'
import LightBackground from 'src/components/LightBackground'
import { useAlert } from 'src/context/AlertContext'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { getCard } from '../../ducks/home.actions'
import TextContent from '../TextContent'

import FormHeader from './FormHeader'
import LastName from './LastName'
import NationalInsuranceNo from './NationalInsuranceNo'
import RegistrationNumber from './RegistrationNumber'

const SmartCheckForm: React.FC = () => {
  const [showInfo, setInfoState] = useState<boolean>(() => false)
  const { payload, loading, error } = useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()
  const { showAlert } = useAlert()

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!payload.cardSerialNumber && !payload.nino) {
      showAlert('Please enter either Registration number or National Insurance No')
      return
    }

    // Dispatch unconditionally. If no captchaToken (or it's expired), the
    // axios wrapper (src/libs/axios/index.ts) opens the captcha modal,
    // waits for the user to solve it, and retries the /card request
    // automatically with the fresh token — no extra click needed.
    const { cardSerialNumber, nino, ...restPayload } = payload
    const apiPayload = {
      ...restPayload,
      ...(cardSerialNumber && { cardSerialNumber }),
      ...(nino && { nino }),
    }

    dispatch(getCard(apiPayload))
  }

  return (
    <LightBackground>
      <FormHeader
        setInfoState={() => {
          setInfoState(true)
        }}
      />
      <form onSubmit={onSubmit} style={{ zIndex: 9 }} className="smart-check-form">
        <style>{`
          .smart-check-form {
            width: 30%;
          }
          @media (max-width: 1000px) {
            .smart-check-form {
              width: 60%;
            }
          }
          @media (max-width: 600px) {
            .smart-check-form {
              width: 90%;
            }
          }
        `}</style>
        <Stack justifyContent="center" alignItems="center" mt={10} spacing={10}>
          <Stack direction="column" spacing={10} sx={{
            width: '100%',
            '@media (max-width: 1000px)': {
              width: '100%',
              gap: 4,
              '& > *': {
                marginLeft: '0 !important',
              },
            },
          }}>
            {showInfo ? (
              <TextContent
                onClose={() => {
                  setInfoState(false)
                }}
              />
            ) : (
              <>
                <Box sx={{
                  width: '100%',
                }}><LastName /></Box>
                <Box sx={{
                  border: '2px solid',
                  borderColor: 'grey.400',
                  borderRadius: 1,
                  p: 5,
                  width: '100%',
                  backgroundColor: 'rgba(245, 245, 245, 0.7)',
                }}>
                  {/* <Typography sx={{ mb: 12 }}>Enter at least one identifier <span style={{ color: '#F90000' }}>*</span></Typography> */}
                  <Stack direction="column" alignItems="center" spacing={4} sx={{
                    '@media (max-width: 1000px)': {
                      flexDirection: 'column',
                    },
                  }}>
                    <Box sx={{
                      flex: 1,
                      width: '100%',
                      '@media (max-width: 1000px)': {
                        paddingLeft: 0,
                      },
                    }}><RegistrationNumber /></Box>
                    <Typography sx={{ my: 0, py: 0 }}>OR</Typography>
                    <Box sx={{
                      flex: 1,
                      width: '100%',
                      '@media (max-width: 1000px)': {
                        paddingRight: 0,
                      },
                    }}><NationalInsuranceNo /></Box>
                  </Stack>
                </Box>
              </>
            )}
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: '100%',
              '@media (max-width: 1600px)': {
                width: '100%',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 8,
              },
            }}
          >
            <Button
              title={loading ? 'Loading' : 'Check Card'}
              type="submit"
              disabled={loading}
            />
          </Stack>

          {error && <Typography color="error">{error}</Typography>}
        </Stack>
      </form>
    </LightBackground>
  )
}

export default SmartCheckForm
